<template>
  <div id="viewer-control">
    <div class="sticky-wrapper">
      <SMV />
      <h2 class="viewer-title">
        Code
      </h2>
      <div class="viewer-content">
        <div class="tabs">
          <Actions />
          <Tab
            title="Inline"
            type="inline"
          />
          <Tab
            title="Script"
            type="script"
          />
        </div>
        <CodeScript
          v-if="mode === 'script'"
          :options="settings.options"
          :mobile-options="settings.optionsMobile"
        />
          <CodeInline
          v-else-if="mode === 'inline'"
          :smv="settings.smv"
          :options="settings.options"
        />
        <StyleComponent :css="settings.optionsCSS" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Actions from '@/widgets/common/Actions'
import Tab from '@/widgets/common/Tab'
import CodeScript from '@/widgets/common/CodeScript'
import CodeInline from '@/widgets/common/CodeInline'
import SMV from '@/widgets/common/SMV'
import StyleComponent from '@/widgets/common/StyleComponent'
export default {
  components: {
    Actions,
    Tab,
    CodeScript,
    CodeInline,
    StyleComponent,
    SMV
  },
  computed: {
    ...mapState([
      'mode',
      'settings',
      'enableMobileOptions'
    ]),
  }
}
</script>
<style lang="scss">
.sticky-wrapper {
  position: sticky;
  top: 90px;
}

#viewer-control {
  box-shadow: 0 8px 40px rgba(50,123,186,.16),
  0 4px 4px rgba(50,123,186,.08);
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  width: 100%;
  @media only screen and (min-width : 992px){
    width: calc(100% - 700px);
  }
}
.viewer {
  //min-height: 300px;
  @media only screen and (min-width : 1300px){
    min-height: 360px;
  }
}

#smv {
  max-width: 100%;
  height: 100%;
  top: 50%;

  @media only screen and (min-width : 992px){
    margin: 0 auto;
  }

  @media only screen and (min-width : 1200px){
    transform: translateY(-50%);
  }
}

.tabs{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 15px;
  flex-wrap: wrap;
  &__item {
    margin: 0 2px;
    border: none;
    padding: 5px 10px;
    background-color: #FCFDFE !important;
    color: #6c7683 !important;
    transition: background-color .5s ease, color .5s ease;
    cursor: pointer;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    outline: none !important;
    &.active {
      background-color: #F5F6F9 !important;
      color: #000 !important;
    }
  }

  @media only screen and (min-width : 400px){
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
}
</style>
